import*as c from"react";var o=(e,t)=>{typeof e=="function"?e(t):e&&typeof e=="object"&&"current"in e&&(e.current=t)},R=(...e)=>c.useCallback(t=>void e.forEach(a=>void o(a,t)),[e]),f=R;export{f as default};
